import {
  inquiryDetail,
  inquiryAddRemind,
  inquiryDelRemind,
  inquiryFollowupList,
  inquiryAddFollowup,
  inquiryDelFollowup,
  inquiryDelFollowupReply,
  inquiryAddComment,
  inquiryCommentList,
  inquiryDelComment,
  inquiryDelCommentReply,
  inquiryHistoryList,
  inquiryHistoryDetail,
  inquiryDelete,
  inquiryArchive,
  inquirySyncxiaoman,
  followupSyncxiaoman,
  updateInquiryFromInfo,
  getArchiveTypes,
  editReceptMethod
} from '@/services/inqueryServices'
import { fetchClueInfoData, eidtClueFollowTime, eidtClueRemarks } from '@/services/clue'
import { isMobile } from '@/lib/device'

import _ from 'lodash'
import moment from 'moment'
import i18n from '@/lib/language'

const state = {
  loading: true,
  submitting: false,
  detailData: {},
  followup: {
    remind: {
      time: '',
      content: ''
    },
    info_type: '',
    new: '',
    list: [],
    next_followup_time: '',
    followup_config_addfields: []
  },
  comment: {
    new: '',
    list: []
  },
  historyList: {
    list: [],
    count: ''
  },
  historyDetail: {},
  joinTeamCascaderShow: true,
  isBeiAn: false,
  isDeal: false,
  formError: {},
  repeatSaveItems: {},
  archiveTypesData: [],
  isClue: false
}

const getters = {
  permissionInfo (state) {
    const { permission_info: permissionInfo = {} } = state.detailData || {}
    // TODO: test
    // permissionInfo.is_edit_beian = 1
    return permissionInfo
  },
  receptionInfo (state) {
    const { reception_info: receptionInfo = {} } = state.detailData || {}
    delete receptionInfo.sort
    return receptionInfo
  },
  fromInfo (state) {
    const { from_info: fromInfo = {}, info = {} } = state.detailData || {}
    let { child = [] } = fromInfo
    if (!fromInfo) return {}

    let data = {
      ...state.detailData.from_info,
      fieldtype: 'select',
      childObj: _.reduce(
        child,
        (res, item) => {
          res[item.id] = item
          return res
        },
        {}
      ),
      options: [],
      fieldconfig: {
        placeholder: i18n.t('message["887"]')
      },
      isneeded: info.clue_id ? 0 : 1
    }
    // 审核详情，设置来源的下拉选项
    if (child.length) {
      child.forEach(item => {
        let obj = { id: item.id, name: item.fieldname, fieldkey: item.fieldkey }
        // if (item.child && item.child.length) {
        data.options.push(obj)
        // }
      })
    }
    return data
  },
  formData (state, getters) {
    const detailData = _.cloneDeep(state.detailData)
    const { info = {} } = detailData
    const { is_shared: isShared = 0 } = info
    const tempInfo = info.clue_id ? info : {}

    let data = {
      /* base_info: detailData.base_info || {},
      deal_info: detailData.deal_info || {},
      demand_info: detailData.demand_info || {},
      contact_info: detailData.contact_info || {}, */
      ...detailData,
      reception_info: detailData.reception_info || {},
      from_info: getters.fromInfo || {},
      info: {
        fieldkey: 'info',
        fieldname: i18n.t('message["933"]'),
        ...tempInfo,
        is_shared: isShared === 1,
        joinTeamCascaderShow: state.joinTeamCascaderShow
      }
    }
    data.from_info = getters.fromInfo
    delete data.permission_info
    delete data.data_from
    if (info.clue_id) {
      data.info.clueUserId = info.dev_userid
    }

    return data
  },
  passdetailMemberInfo () {
    const { detailData = {} } = state
    const { info } = detailData
    return info
  },
  memberInfo (state) {
    const { detailData } = state
    const { info } = detailData
    if (!detailData || !info) return

    let childValueObj = {}
    for (let k in info) {
      if (k.indexOf('_') !== -1) {
        if (k === 'audit_status_desc') continue

        const key = k.split('_') && k.split('_')[0]
        const key2 = k.split('_') && k.split('_')[1]

        if (
          key === 'input' ||
          key === 'audit' ||
          key === 'dev' ||
          key === 'follow'
        ) {
          childValueObj[key] = childValueObj[key] || {}
          childValueObj[key][key2] = info[k]
        }
        // if (key === 'dev' && (info['dev_userid'] === 0)) {
        //   childValueObj['dev']['roleid'] = 'null'
        //   childValueObj['dev']['userid'] = -1
        // }
        if (info && info.divide_type && key === 'follow') {
          childValueObj.follow.divide_type = info.divide_type
        }
      }
    }

    const {
      input_time: inputTime,
      input_truename: inputTruename,
      audit_status: auditStatus,
      audit_status_desc: auditStatusDesc,
      audit_truename: auditTruename
    } = state.detailData.info

    let child = [
      {
        fieldkey: 'input_time',
        fieldname: i18n.t('message["621"]'),
        fieldtype: 'string',
        fieldvalue: inputTime ? moment(inputTime * 1000).format('YYYY-MM-DD HH:mm:ss') : '--'
      },
      {
        fieldkey: 'input',
        fieldname: i18n.t('message["620"]'),
        fieldtype: 'string',
        fielddesc: inputTruename,
        fieldvalue: [],
        info: childValueObj.input
      },
      {
        fieldkey: 'follow',
        fieldname: i18n.t('message["373"]'),
        fieldtype: 'string',
        fieldvalue: [],
        isneeded: 1,
        info: childValueObj.follow
      },
      {
        fieldkey: 'audit',
        fieldname: i18n.t('message["1047"]'),
        fieldtype: 'string',
        fielddesc: auditTruename,
        fieldvalue: [],
        info: childValueObj.audit
      },
      {
        fieldkey: 'dev',
        fieldname: i18n.t('message["549"]'),
        fieldtype: 'string',
        fieldvalue: [],
        isneeded: info.devuser_isneeded === 1 ? 1 : 0,
        info: childValueObj.dev
      },
      {
        fieldkey: 'audit_status',
        fieldname: i18n.t('message["1379"]'),
        fieldtype: 'string',
        fielddesc: auditStatusDesc,
        fieldvalue: auditStatus
      }
    ]

    let childObj = _.reduce(
      child,
      (res, item) => {
        res[item.fieldkey] = item
        return res
      },
      {}
    )
    let data = {
      ...state.detailData.info,
      child,
      childObj
    }
    if (state.detailData.info.is_shared === 1) {
      data.is_shared = true
    } else {
      data.is_shared = false
    }
    return data
  }
}

const mutations = {
  SET_LOADING (state, data) {
    state.loading = data
  },
  UPDATA_DETAIL (state, data) {
    state.detailData = data
  },
  GET_FOLLOWUP (state, data) {
    data.list = data.list.map(item => {
      if (item.pics && item.pics.length) {
        item.pics = item.pics.map(pic => {
          pic.description = pic.file_name
          pic.href = pic.file_url
          pic.title = i18n.t('message["1304"]')
          return pic
        })
      }
      return item
    })

    state.followup.list = data.list
  },
  SET_FOLLOWUP (state, data) {
    state.followup.info_type = data.info_type
    if (data.hasOwnProperty('remindChecked') === false || data.remindChecked) {
      state.followup.remind.time = data.followup_remind_time
      state.followup.remind.content = data.followup_remind_content
    }
  },
  SET_NEXT_TIME (state, data) {
    state.followup.next_followup_time = data
      ? moment(data * 1000).format('YYYY-MM-DD HH:mm')
      : ''
  },
  SET_REMIND (state, data) {
    state.followup.remind.time = data.time
      ? moment(data.time * 1000).format('YYYY-MM-DD HH:mm')
      : ''
    state.followup.remind.content = data.content
  },
  SET_FOLLOW_CONFIG (state, data) {
    state.followup.followup_config_addfields = data || []
  },
  GET_COMMENT (state, data) {
    state.comment.list = data.list
  },
  GET_HISTORY (state, data) {
    state.historyList.list = data.list
    state.historyList.count = data.count
  },
  GET_HISTORY_DETAIL (state, data = {}) {
    state.historyDetail = data
  },

  SET_SUBMITTING (state, type) {
    state.submitting = type
  },
  updataJoinTeamCascaderShow (state, data) {
    state.joinTeamCascaderShow = data
  },
  /**
   * Boolean
   * 存放是否选择了备案
   */
  updataIsBeiAn (state, data) {
    state.isBeiAn = data
  },
  /**
   * Boolean
   * 存放是否选择了成交
   */
  UPDATE_IS_DEAL (state, data) {
    state.isDeal = data
  },
  /**
   * Object
   * 存放表单需要额外校验的字段，手机号和邮箱列表校验时
   */
  SER_FORM_ERROR (state, data = {}) {
    state.formError = data
  },
  /**
   * Object
   * 存放查重字段的 key 和重复是否可以保存的状态， 如：{ mobiles: 1 }
  */
  UPDATE_REPEAT_SAVE_ITEMS (state, data = {}) {
    state.repeatSaveItems = data
  },
  // 手动归档参数类型数据
  setArchiveTypesData (state, data) {
    state.archiveTypesData = data
  },
  setIsClue (state, b) {
    state.isClue = b
  }
}

const actions = {
  async fetchDetail ({ commit }, data) {
    commit('SET_LOADING', true)
    let chain = null
    if (data && data.type && data.type === 'clue' && !isMobile) {
      chain = await fetchClueInfoData()
      commit('setIsClue', true)
    } else {
      chain = await inquiryDetail()
    }
    chain.onSuccess(async payload => {
      commit('UPDATA_DETAIL', payload)
      commit('SET_LOADING', false)

      const { info = {} } = payload

      commit('SET_REMIND', {
        time: info.followup_remind_time,
        content: info.followup_remind_content
      })

      commit('SET_NEXT_TIME', info.next_followup_time)
      commit('SET_FOLLOW_CONFIG', info.followup_config_addfields)
    })
    return chain
  },
  async deleteDetail ({ commit }) {
    const chain = await inquiryDelete().onSuccess(async payload => {
      //
    })
    return chain
  },
  async archiveInquiry ({ commit }) {
    const chain = await inquiryArchive()
    return chain
  },
  async inquirySyncxiaoman ({ commit }, params) {
    const chain = await inquirySyncxiaoman()
    chain
      .params(params)
      .fetch()
    return chain
  },
  async followupSyncxiaoman ({ commit }, params) {
    const chain = await followupSyncxiaoman()
    chain
      .params(params)
      .fetch()
    return chain
  },
  async fetchFollowupList ({ commit }) {
    commit('GET_FOLLOWUP', { list: [] })
    const chain = await inquiryFollowupList().onSuccess(async payload => {
      commit('GET_FOLLOWUP', payload)
    })
    return chain
  },
  async inquiryAddRemind ({ commit }, data) {
    const chain = await inquiryAddRemind().onSuccess(async payload => {
      let time = new Date(data.time).getTime()
      commit('SET_REMIND', {
        time: time / 1000,
        content: data.content
      })
    })
    return chain
  },
  async inquiryDelRemind ({ dispatch, commit }) {
    const chain = await inquiryDelRemind().onSuccess(async payload => {
      commit('SET_REMIND', {
        time: '',
        content: ''
      })
      // return dispatch('fetchDetail')
    })
    return chain
  },
  async inquiryAddFollowup ({ dispatch, commit }, params) {
    const chain = await inquiryAddFollowup()
      .params(params)
      .onSuccess(async payload => {
        commit('SET_FOLLOWUP', params) // 成功之后再更新
      // return dispatch('fetchFollowupList')
      })
    return chain
  },
  async inquiryDelFollowup ({ dispatch, commit }) {
    const chain = await inquiryDelFollowup().onSuccess(async payload => {
      // return dispatch('fetchFollowupList')
    })
    return chain
  },
  async inquiryDelFollowupReply ({ dispatch, commit }, params) {
    const chain = await inquiryDelFollowupReply()
    chain
      .params(params)
      .fetch()
    return chain
  },
  async inquiryAddComment ({ dispatch, commit }, params) {
    commit('setSubmitting', true)
    const chain = await inquiryAddComment()
      .params(params)
      .onSuccess(async payload => {
        // return dispatch('fetchCommentList')
      })
      .onNetComplete(() => {
        commit('SET_SUBMITTING', false)
      })
    return chain
  },
  async fetchCommentList ({ commit }) {
    const chain = await inquiryCommentList().onSuccess(async payload => {
      commit('GET_COMMENT', payload)
    })
    return chain
  },
  async inquiryDelComment ({ dispatch, commit }, params) {
    const chain = await inquiryDelComment()
    chain.params(params).fetch()
    return chain
  },
  async inquiryDelCommentReply ({ dispatch, commit }, params) {
    const chain = await inquiryDelCommentReply()
    chain.params(params).fetch()
    return chain
  },
  async fetchHistoryList ({ commit }) {
    const chain = await inquiryHistoryList().onSuccess(async payload => {
      commit('GET_HISTORY', payload)
    })
    return chain
  },
  async fetchHistoryDetail ({ commit }) {
    commit('GET_HISTORY_DETAIL', {})
    const chain = await inquiryHistoryDetail().onSuccess(async payload => {
      commit('GET_HISTORY_DETAIL', payload)
    })
    return chain
  },
  async editInquiryFromInfo ({ commit }, params) {
    const chain = await updateInquiryFromInfo()
    chain
      .params(params)
      .fetch()
    return chain
  },
  async getArchiveTypes ({ commit }, params) {
    const chain = await getArchiveTypes()
    chain
      .params(params)
      .onSuccess(payload => {
        commit('setArchiveTypesData', payload)
      })
      .fetch()
    return chain
  },
  async editReceptMethod ({ commit }, params) {
    const chain = await editReceptMethod()
    chain
      .params(params)
      .onSuccess(payload => {
      })
      .fetch()
    return chain
  },
  // async checkClue ({ commit }, params) {
  //   const chain = await checkClue()
  //   chain
  //     .params(params)
  //     .onSuccess(payload => {
  //     })
  //   return chain
  // },
  // 编辑线索备注
  async eidtClueRemarks ({ commit }, params) {
    const chain = await eidtClueRemarks()
    chain
      .params(params)
      .onSuccess(payload => {
      })
      .fetch()
    return chain
  },
  // 编辑线索备注
  async eidtClueFollowTime ({ commit }, params) {
    const chain = await eidtClueFollowTime()
    chain
      .params(params)
      .onSuccess(payload => {
      })
      .fetch()
    return chain
  }

}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
}
